import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import styles from "./Footer.module.css";
import { FaWhatsapp, FaLinkedin, FaInstagram, FaEnvelope, FaPhone } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <section className={styles.footerCta}>
        <div className={styles.container}>
          <div className={styles.ctaContent}>
            <div className={styles.ctaText}>
              <h2>
                <FormattedMessage id="footer.cta.title" />
              </h2>
              <p>
                <FormattedMessage id="footer.cta.subtitle" />
              </p>
            </div>
            <div className={styles.ctaContact}>
              <div className={styles.contactInfo}>
                <h3>
                  <FormattedMessage id="footer.contact.title" />
                </h3>
                <span>
                  <FaEnvelope size={14} className={styles.contactIcon}/> info@vertex4d.ai
                </span>
                <span>
                  <FaPhone size={14} className={styles.contactIcon}/> +55 71 99690-1891
                </span>
              </div>
              <div className={styles.contactSocial}>
                <a
                  href="https://wa.me/5571996901891"
                  aria-label="WhatsApp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp />
                </a>
                <a
                  href="https://www.linkedin.com/company/dronessolution"
                  aria-label="LinkedIn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="https://www.instagram.com/vertex.4d"
                  aria-label="Instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer className={styles.footer}>
        <p>
          <FormattedMessage
            id="footer.copyright"
            values={{ year: new Date().getFullYear() }}
          />
        </p>
      </footer>
    </>
  );
};

export default injectIntl(Footer);

